import { UNIT_STATUSES } from 'constants/unit';

export const foundUnitStatus = (value: number) => {
  return UNIT_STATUSES.find(item => item.value === value);
};
